import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_material_aliasesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialId?: number }): 
  Promise<{ result: { MaterialId?: number, AccountId?: number, MaterialAliasDescription?: string, MaterialAliasLookupCode?: string, MaterialAliasName?: string, SalesOrderDiscount?: number, Account?: { LookupCode?: string, Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { materialId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { MaterialId?: number, AccountId?: number, MaterialAliasDescription?: string, MaterialAliasLookupCode?: string, MaterialAliasName?: string, SalesOrderDiscount?: number, Account?: { LookupCode?: string, Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { materialId?: number, $keys: { MaterialId?: number, AccountId?: number }[] }): 
  Promise<{ result: { MaterialId?: number, AccountId?: number, MaterialAliasDescription?: string, MaterialAliasLookupCode?: string, MaterialAliasName?: string, SalesOrderDiscount?: number, Account?: { LookupCode?: string, Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialId?: number    }) {
      return false;
    }
}
